import { render, staticRenderFns } from "./AdminLocationList.vue?vue&type=template&id=7a28a4ae&scoped=true&"
import script from "./AdminLocationList.vue?vue&type=script&lang=ts&"
export * from "./AdminLocationList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLocationList.vue?vue&type=style&index=0&id=7a28a4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28a4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VDataTable,VTextField})
